import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    eventLogHeader: {
        minWidth: '110px',
    },
});
